import React, { useEffect, useState} from 'react';
import Modalheader from "components/modal/components/header";
import ModalBody from "components/modal/components/body";
import ModalFooter from "components/modal/components/footer";
import Button from "components/button";
import Banner from "components/banner/banner";
import Apidatabase from 'server'
import useModal from "components/modal/useModal";
import {toast} from "react-toastify";
import UseContext from "hooks/useContext";

const ModalMateriel = () => {
    const {refreshLoadWorker} = UseContext()
    const {toggle} = useModal()
    const [datas, setDatas] = useState([])
    const [tool, setTool] = useState('')
    const [sucess, setSucess] = useState(false)
    useEffect(() => {
        Apidatabase.getListTools((data) => {
                setDatas(data)
            }, (err) => {
                console.log(err)
            }
        )

    }, [setDatas])

    const handleSubmit = (e) => {
        setSucess(false)
        e.preventDefault()
        if (tool !== '') {
            Apidatabase.postUserTool({ tools: tool }, (data) => {
                if (data.errors) {
                    console.log(data.errors)
                } else {
                    refreshLoadWorker()
                    toast.success(`Votre matériel ${tool} est ajouté`)
                }
            }, (err) => {
                console.log(err)
            })
        }
    }
    return (
        <>

            <Modalheader hide={toggle} hideShow={true}>Ajouter un matériel
                possédé</Modalheader>
            <ModalBody>
                <Banner type={'info'}>Ajouter un matériel possédé, c’est s’engager à le
                    rapporter le jour où il est demandé dans le cadre de certaines
                    missions.</Banner>
                <form className='mt-4'>
                    <select name="tool" size='1'
                            className="w-full h-10 pl-3 pr-8 ft-b placeholder-gray-400 border rounded-lg  "
                            onChange={(e) => {
                                setTool(e.target.value)
                            }}>
                        <option value="">Sélectionner</option>
                        {datas.map(data =>
                            <option key={data._id}
                                    value={`${data.name}`}>{data.name}</option>
                        )}
                    </select>
                </form>
            </ModalBody>
            <ModalFooter>
                <Button size={'LG'} color={'SECONDARY'} onClick={toggle}>Annuler</Button>
                <Button size={'LG'} onClick={handleSubmit}>Confirmer</Button>
            </ModalFooter>
        </>
    );
};

export default ModalMateriel;